import { c as _c } from "react/compiler-runtime";
import { SnackbarItemPropertiesType } from "@website/ui/snackbar/components/snackbar-item/snackbar-item.types";
import { KeyboardEvent, MouseEvent, useEffect, useRef, useState } from "react";
const stopClickPropagation = (event: MouseEvent<HTMLDivElement>) => {
  event.stopPropagation();
};
const stopKeyDownPropagation = (event: KeyboardEvent<HTMLDivElement>) => {
  event.stopPropagation();
};
export const useSnackbarItem = properties => {
  const $ = _c(17);
  const {
    dequeue,
    severity,
    title,
    id,
    size,
    Action,
    duration
  } = properties;
  const [show, setShow] = useState(false);
  const timeout = useRef(null);
  let t0;
  let t1;
  if ($[0] !== dequeue || $[1] !== duration || $[2] !== id) {
    t0 = () => {
      setShow(true);
      timeout.current = setTimeout(() => {
        setShow(false);
        setTimeout(() => {
          dequeue(id);
        }, 150);
      }, duration === "short" ? 3000 : 8000);
      return () => {
        clearTimeout(timeout.current as number);
      };
    };
    t1 = [dequeue, duration, id];
    $[0] = dequeue;
    $[1] = duration;
    $[2] = id;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== dequeue || $[6] !== id) {
    t2 = () => {
      clearTimeout(timeout.current as number);
      setShow(false);
      setTimeout(() => {
        dequeue(id);
      }, 150);
    };
    $[5] = dequeue;
    $[6] = id;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onClose = t2;
  let t3;
  if ($[8] !== Action || $[9] !== onClose || $[10] !== severity || $[11] !== size || $[12] !== title) {
    t3 = {
      onClose,
      onClick: stopClickPropagation,
      onKeydown: stopKeyDownPropagation,
      severity,
      title,
      size,
      Action
    };
    $[8] = Action;
    $[9] = onClose;
    $[10] = severity;
    $[11] = size;
    $[12] = title;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== show || $[15] !== t3) {
    t4 = {
      alertProps: t3,
      show
    };
    $[14] = show;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};